/**
 * 组件列表
 * 走服务端约定 http://confluence.mockuai.com/pages/viewpage.action?pageId=9182572
 */

import { Message } from 'element-ui';
import activeDay from './components/TmsActiveDay/mod';
import activeDay2 from './components/TmsActiveDay2/mod';
import activeDay3 from './components/TmsActiveDay3/mod';
import activeSpecial from './components/TmsActiveSpecial/mod';
import activeMaterial from './components/TmsActiveMaterial/mod';
import activeItem from './components/TmsActiveItem/mod';
import TmsAnchor from './components/TmsAnchor/mod';
import BackTop from './components/TmsBackTop/mod';
import BizItem from './components/TmsBizItem/mod';
import redPacket from './components/TmsBizRedPacket/mod';
import BottomFloat from './components/TmsBottomFloat/mod';
import ContactInfo from './components/TmsContactInfo/mod';
import CopyText from './components/TmsCopyText/mod';
import CountDown from './components/TmsCountdown/mod';
import CustomMenu from './components/TmsCustomMenu/mod';
import FixIcon from './components/TmsFixIcon/mod';
import Form from './components/TmsForm/mod';
import ImageList from './components/TmsImageList/mod';
import ImageSet from './components/TmsImageSet/mod';
import JumpApp from './components/TmsJumpApp/mod';
import MiddleNav from './components/TmsMiddleNav/mod';
import rule from './components/TmsRule/mod';
import TmsButton from './components/TmsButton/mod';
import ShopHeader from './components/TmsShopHeader/mod';
import SplitLine from './components/TmsSplitLine/mod';
import SwiperNav from './components/TmsSwiperNav/mod';
import text from './components/TmsText/mod';
import title from './components/TmsTitle/mod';
import TopNav from './components/TmsTopNav/mod';
import UserKpi from './components/TmsUserKpi/mod';
import video from './components/TmsVideo/mod';
import newcomerReport from './components/TmsNewcomerReport/mod';
// 组件对应的 iconfont
export const ICON_LIST = {
  text: 'icon-text',
  title: 'icon-title',
  image_list: 'icon-image_list',
  button: 'icon-btn'
};

const config = {
  base: [
    ImageSet,
    ImageList,
    text,
    title,
    TmsButton,
    SplitLine,
    rule,
    CountDown,
    CopyText,
    video,
    ShopHeader,
    ContactInfo,
    CustomMenu,
    TopNav,
    MiddleNav,
    BottomFloat,
    JumpApp,
    FixIcon,
    SwiperNav,
    activeItem,
    TmsAnchor,
    BackTop,
    BizItem,
    newcomerReport
  ],
  business: [redPacket, Form, UserKpi],
  activeList: [activeDay, activeDay2, activeDay3, activeSpecial, activeMaterial]
};

export default config;

class CheckId {
  constructor(config) {
    try {
      this.config = config;
      this.allList = [];
      this.setAllList();
      this.checkIdEmpty();
      this.checkIdRepeat();
    } catch (error) {
      Message.error(error.message);
    }
  }
  setAllList() {
    Object.keys(this.config).some(key => {
      const item = this.config[key];
      this.allList.push(...item);
    });
  }
  checkIdEmpty() {
    let message = '';
    this.allList.some((item, index) => {
      if (item.id === undefined) {
        message = `配置 第 ${index}项无ID`;
        return true;
      }
    });
    if (message) {
      throw new Error(message);
    }
  }
  checkIdRepeat() {
    const obj = {};
    let message = '';
    this.allList.some(item => {
      if (obj[item.id]) {
        message = `id ${item.id} 重复`;
        return true;
      } else {
        obj[item.id] = 1;
      }
    });
    if (message) {
      throw new Error(message);
    }
  }
}
new CheckId(config);